/* eslint-disable @typescript-eslint/camelcase */
import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
import { IS_SENDER_ACCOUNT } from "@/app/infrastructures/misc/Utils";
import {
  ForgotPasswordRequestInterface,
  ResetPasswordRequestInterface,
  LoginRequestInterface,
  LogoutRequestInterface,
  VerificationAccountRequestInterface
} from "@/data/payload/contracts/AuthRequest";

export class LoginApiRequest implements LoginRequestInterface {
  email: string;
  private password: string;

  constructor(email: string, password: string) {
    this.email = email;
    this.password = password;
  }

  public toJSON() {
    const email = this.email;
    const password = this.password;

    if (IS_SENDER_ACCOUNT) {
      return JSON.stringify({
        phone_number: "+62" + email,
        password
      });
    }
    return JSON.stringify({
      email,
      password
    });
  }
}

export class DeviceAuthApiRequest implements LoginRequestInterface {
  email = "";
  password = "";
  recaptchaToken = "";

  constructor(fields?: Partial<DeviceAuthApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON() {
    const email = this.email;
    const password = this.password;

    return JSON.stringify({
      email,
      password
    });
  }
}

export class ForgotPasswordApiRequest
  implements ForgotPasswordRequestInterface {
  private email: string;

  constructor(email: string) {
    this.email = email;
  }

  public toJSON() {
    const email = this.email;

    return JSON.stringify({ email });
  }
}

export class ResetPasswordApiRequest implements ResetPasswordRequestInterface {
  private email: string;
  private password: string;
  private token: string;
  constructor(email: string, password: string, token: string) {
    this.email = email;
    this.password = password;
    this.token = token;
  }

  public toJSON() {
    const email = this.email;
    const password = this.password;
    const token = this.token;

    return JSON.stringify({
      email,
      password,
      token
    });
  }
}

export class EditPasswordApiRequest implements ResetPasswordRequestInterface {
  oldPassword = "";
  newPassword = "";
  token = "";
  otp = "";
  version = "v1";
  constructor(fields?: Partial<EditPasswordApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return ConvertObjectCamelToSnakeCaseV2(this);
  }
}

export class LogoutApiRequest implements LogoutRequestInterface {
  public toJSON() {
    return JSON.stringify({});
  }
}

export class VerificationAccountRequest
  implements VerificationAccountRequestInterface {
  emailOrUsername: string;
  question: string;
  answer: string;
  captchaToken: string;
  constructor(emailOrUsername: string, question: string, answer: string, captchaToken: string) {
    this.emailOrUsername = emailOrUsername;
    this.question = question;
    this.answer = answer;
    this.captchaToken = captchaToken;
  }

  public toJSON(): string {
    return JSON.stringify({
      email_or_username: this.emailOrUsername,
      question: this.question,
      answer: this.answer,
      captcha_token: this.captchaToken
    });
  }
}

export class VerificationOTPRequest {
  otp = "";
  token = "";

  constructor(fields?: Partial<VerificationOTPRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return JSON.stringify({
      otp: this.otp,
      token: this.token
    });
  }
}

export class SetupPasswordRequest {
  password = "";
  email = "";
  token = "";
  constructor(fields?: Partial<SetupPasswordRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return JSON.stringify({
      password: this.password,
      email: this.email,
      token: this.token
    });
  }
}

export class OtpRequest implements VerificationAccountRequestInterface {
  password = "";
  captchaToken = "";
  action = "";
  newEmail = "";
  constructor(fields?: Partial<OtpRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return ConvertObjectCamelToSnakeCaseV2(this);
  }
}

export class Login2faApiRequest {
  email = "";
  password = "";

  constructor(fields?: Partial<Login2faApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return JSON.stringify({ email: this.email, password: this.password });
  }
}

export class OtpRequestLogin2faApiRequest {
  challengeToken = "";
  captchaToken = "";

  constructor(fields?: Partial<OtpRequestLogin2faApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return JSON.stringify({
      challenge_token: this.challengeToken,
      captcha_token: this.captchaToken
    });
  }
}

export class OtpVerifySkipApiRequest {
  challengeToken = "";

  constructor(fields?: Partial<OtpVerifySkipApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return JSON.stringify({ challenge_token: this.challengeToken });
  }
}

export class OtpVerifyLogin2faApiRequest {
  challengeToken = "";
  token = "";
  otp = "";

  constructor(fields?: Partial<OtpVerifyLogin2faApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return JSON.stringify({
      challenge_token: this.challengeToken,
      token: this.token,
      otp: this.otp
    });
  }
}

export class SetupPasswordValidationApiRequest {
  token = "";
  email = "";
  constructor(fields?: Partial<SetupPasswordValidationApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    return ConvertObjectCamelToSnakeCaseV2(this);
  }
}
